// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles_iconWrapper__lh1HW","heading":"styles_heading__avgBW","subtitle":"styles_subtitle__0hAEv","description":"styles_description__URDqI"};